mainApp.directive('eventsChart', function() {
    return {
        templateUrl: '/public/directives/charts/eventsChart.html',
        scope: {
            data: '=?',
            field: '@?',
            filters: '=?',
            facets: '=?',
            datamodified: '=?',
            waitforfilter: '@?',
            showfilterballoon: '@?',
            pageMargin: '=',
            facetsUpdated: '=?'
        },
        controller: ['$scope', '$location', '$sce', '$state', '$element', '$timeout', '$filter', 'IconsService', 'GeneralUtilsService', 'DateRangeService', 'RulesService',
            function ($scope, $location, $sce, $state, $element, $timeout, $filter, IconsService, GeneralUtilsService, DateRangeService, RulesService) {
            $scope.itemsConfig = {
                defer: true,
            };

            $scope.dateRange = DateRangeService.getNewRange();
            DateRangeService.initDateRange($scope.dateRange, true);
            $scope.currentZoom = 1;
            $scope.data = $scope.data || {};
            $scope.auData = [];
            $scope.aggregationConfig = {};
            $scope.avExceptionDuration = null;
            $scope.accountId = $state.params.accountId;
            $scope.pageSize = 9;

            var MULTIPLE_CATEGORIES_DISPLAY_TEXT = "Multiple";
            var icons = IconsService.getIcons();
            var $filtersWrapper, $eventsCharDiv, $clearZoom, eventsChart, ready, readyTimeout;
            var addFilter;
            var facets = [];

            function updateState() {
                var fromDate = $scope.dateRange.from.getTime();
                var toDate = $scope.dateRange.to.getTime();
                var interval = Math.max(Math.floor((toDate - fromDate) / 100), 60); // min interval size is 1 min - elastic search data provider expect to get inverval in milliseconds

                console.log($scope.tableConfig.aggregationConfig);
                DateRangeService.zoomTo(fromDate, toDate, interval, false);
            }

            $scope.$watch('dateRange', function (newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    updateState();
                }
            }, true);

            $scope.$watch('filters', function(newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    $scope.tableConfig.addFilter = newValue || {};
                    refreshTable();
                }
            }, true);

            $scope.clearZoom = function() {
                $scope.dateRange.from = null;
                $scope.dateRange.to = null;
                setAggConfig();
                refreshTable();
            };

            $scope.removeFilters = function(){
                $state.go('app.events', {
                    filter: null,
                    url_category: null,
                    app_rule_id: null,
                    access_rule_id: null,
                    type: null,
                });
            };

            $scope.selectAlert = function(alertId){
	             store.fetch({
			        path: '/getAlert?accountId=' + $state.params.accountId + '&alertId=' + alertId,
			        success: function(data) {
			            $scope.alertContent = $sce.trustAsHtml(data.html);
			        },
	            });
            };

            $scope.goToEditPage = function(goToAudit){
                var accountId = $state.params.accountId;
                if(goToAudit){
                    var type = '';
                    var params = {};
                    params.id = $scope.scopeSelection.id;
                    if ($scope.scopeSelection.type === 'appRule') {
                        params.type = 'apprule';
                    } else if ($scope.scopeSelection.type === 'accessRule') {
                        params.type = 'accessrule';
                    } else if ($scope.scopeSelection.type === 'urlFiltering') {
                        params.type = 'urlfilteringrule';
                        params.id = null;
                        params.modelName = +$scope.scopeSelection.id;
                    } else if ($scope.scopeSelection.type === 'groups') {
                        params.type = 'group';
                    } else {
                        params.type = $scope.scopeSelection.type;
                    }
                    $state.go('app.audit', params);
                } else if ($scope.scopeSelection.type === 'appRule') {
                    $state.go('app.appRules', {
                        ruleId: $scope.scopeSelection.id,
                    });
                } else if ($scope.scopeSelection.type === 'accessRule') {
                    $state.go('app.connectionRules', {
                        ruleId: $scope.scopeSelection.id,
                    });
                } else if ($scope.scopeSelection.type === 'OUTBOUND_INTERNET_FIREWALL_RULE') {
                    $state.go('app.internetFW', {
                        ruleId: $scope.scopeSelection.id,
                    });
                } else if ($scope.scopeSelection.type === 'WAN_FIREWALL_RULE') {
                    $state.go('app.wanFW', {
                        ruleId: $scope.scopeSelection.id,
                    });
                }
                else if($scope.scopeSelection.type === "urlFiltering"){
                    if ($scope.scopeSelection.item.type_value === "URLFILTERCUSTOMCATEGORYRULE") {
                        $state.go('app.urlFiltering', {
                            customCategoryName: $scope.scopeSelection.id
                        });
                    }
                    else {
                        $state.go('app.urlFiltering', {
                            categoryName: $scope.scopeSelection.id
                        });
                    }
                }
                else if($scope.scopeSelection.type === "groups"){
                    $state.go('app.groups', {
                        groupId: $scope.scopeSelection.id
                    });
                }
                else if($scope.scopeSelection.type === "healthRule"){
                    $state.go('app.accountAlertsRules', {
                        ruleId: $scope.scopeSelection.id
                    });
                }
            };

            $scope.saveException = function () {
                var item = $scope.scopeSelection.item;
                var path, params, fileName, name, hash;

                if(item.id){
                    path = "/edit";
                    params = {'avexceptionId':item.id,'accountId': $state.params.accountId,'save':true, 'fields':"['expirationDate','comment']"};
                    fileName = item.fileName;
                    name = item.name;
                    hash = item.hash;
                }
                else {  //new item
                    path = "/add";
                    params = {accountId: $state.params.accountId, 'type': 'avRuleException', 'save': true};
                    fileName = item.url!== 'N/A' ? item.url.replace(/^.*[\\\/]/, '') : 'N/A';
                    name = item.url;
                    name = item.file_hash;
                }

                var expDate = new Date();
                if (item.avExceptionDuration === "0")
                    expDate = new Date(0);
                else
                    expDate.setDate(expDate.getDate() + parseInt(item.avExceptionDuration));

                store.save({
                    path: path,
                    data: {fileName:fileName,"name":name,"hash":item.file_hash, expirationDate:expDate.getTime(),newSaveMethod:true, comment:item.comment},
                    dataObj: 'json',
                    queryParams: params,
                    success: function(data) {
                        $scope.$root.handleServerResponse(data, "", "Anti Malware exception was added");
                        if(data.status !== "ERROR"){
                            $scope.tableConfig.selectedId = data.model.id;
                            $scope.datamodified = new Date().getTime();
                            $scope.$root.closePopup('avConfigExceptionPopup');
                        }
                    }
                });
            };

            function filter() {
                var monitoringFilter = $scope.$parent.tabFilter;
                if(!addFilter){
                    addFilter = {};
                }

                if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid === 0)){
                    $scope.currentName = monitoringFilter.name;
                    $scope.currentType = monitoringFilter.type;
                    $scope.pid = monitoringFilter.pid;
                    addFilter.Client = {
                        label: 'site_id',
                        values: [$scope.pid],
                    };
                    // if we have a top site filter we change the label (which is the grouping of the field) so this field will not be grouped with the from fields it is usually grouped with.
                    // in case there's a top filter we don't want an OR relationship like we have with fields in the same group but an AND relationship.
                    var siteFields = facets.filter(function(facet) { return facet.id === 'site_id'});
                    if (siteFields.length>0) {
                        siteFields[0].label = 'site';
                    }
                }

                var locationParams = $state.params;
                if(locationParams && locationParams.internalId){
                    var internalId = locationParams.internalId;
                    if(internalId.indexOf("[") === 0 && internalId.indexOf("]") === internalId.length -1){
                        internalId = internalId.replace("[","").replace("]","").replace(/ /g, "");
                    }
                    var internalIdList = internalId.split(',');
                    addFilter.internalId = {
                        label: 'internalId',
                        values: internalIdList,
                    };
                }
                if(locationParams && locationParams.ruleId && locationParams.ruleType){
                    var ruleId = locationParams.ruleId;
                    // the locationParams.ruleType is actually the eventType
                    var label = RulesService.getRuleTypeOfEventType(locationParams.ruleType, locationParams.exception).idField;

                    if (label){
                        addFilter.ruleFilter = {
                            label: label,
                            values: [ruleId]
                        };
                    }
                }
            }

            var alertsAggregationConfig = {
                    index : "alerts",
                    type:"alerts",
                    fields: [{
                    		id: "events.documentGroupId",
                    		label: "documentGroupId",
                    		order: 1
                    }],
                    filter: {
                    	fields: {
                    		type: {
                    			label: "events.documentGroupId",
                    			includeMissing: false,
                    			values: [],
                    			innerAggregationField: ["documentGroupId"]
                    		}
                    	}
                    },
                    dataConfig : {
                        type:"alerts",
                        fromDate : $scope.dateRange.from.getTime(),
                        toDate : $scope.dateRange.to.getTime(),
                        dateField : "startTime",
                        from: 0,
                        limit: 100,
                        orders: [{
                        	path: "startTime",
                        	dir: "DESC"
                        }]
                    }
            };

            var socketSerialAndRoleTemplate = '<span ng-show="item.socketSerial"><b class="caption">Socket S/N</b>: {{item.socketSerial}}</span> <span ng-show="item.configurationRole"><b class="caption">Socket Role</b>: {{item.configurationRole | capitalize}}</span>';

            function init() {
                $scope.$watch('tableConfig.data', function(newValue, oldValue) {
                    if (newValue && !_.isEqual(newValue, oldValue) && (!$scope.waitforfilter || $scope.filters)) {
                        getDataByDates();
                    }
                });
                if($scope.facets){
                    facets = $scope.facets;
                }
                else if ($scope.$root && $scope.$root.tags) {
                    facets = [
                        {"id": "type", label: "Type", order: 1},
                        {"id": "site_id", subLabel:"Name", subOrder:1, label: "From / Src", order: 2},
                        {"id": "admin_id", subLabel:"Name", subOrder:1, label: "From / Src", order: 2},
                        {"id": "tunnel_host_name", subLabel:"Name", subOrder:1, "label": "From / Src", order: 2},
                        {"id": "syncType", subLabel:"Name", subOrder:1, "label": "From / Src", order: 2},
                        {"id": "client_ip", subLabel:"IP", subOrder:2, "label": "From / Src", order: 2},
                        {"id": "client_ip_hostname", subLabel:"IP", subOrder:2, "label": "From / Src", order: 2},
                        {"id": "tunnel_internal_ip", subLabel:"IP", subOrder:2, "label": "From / Src", order: 2},
                        {"id": "tunnel_remote_ip", subLabel:"IP", subOrder:2, "label": "From / Src", order: 2},
                        {"id": "os_type", subLabel: "OS Type", subOrder: 3, label: "From / Src", order: 2},
                        {"id": "tunnel_device_type", subLabel: "OS Type", subOrder: 3, label: "From / Src", order: 2},
                        {"id": "rt_site_id", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id": "appid", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id": "url_category", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id":"url_exception_id",subLabel:"Name", subOrder:1,"label":"To / Dest", order: 3},
                        {"id": "connection_destination_type", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id": "controllerHost", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id": "cats_unified_arr", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id": "cats_custom_arr", subLabel:"Name", subOrder:1, "label": "To / Dest", order: 3},
                        {"id": "controllerIp", subLabel:"IP", subOrder:2, "label": "To / Dest", order: 3},
                        {"id": "action", order: 10},
                        {"id": "documentGroupId", "ignoreFilter": true, "hide": true},
                        {"id": "app_rule_id", "ignoreFilter": true, "hide": true},
                        {"id": "access_rule_id", "ignoreFilter": true, "hide": true},
                        {"id": "controller", "ignoreFilter": true, "hide": true},
                        {"id": "fw_wan_rule_id", "ignoreFilter": true, "hide": true},
                        {"id": "fw_inet_rule_id", "ignoreFilter": true, "hide": true},
                        {"id": "url_category", "ignoreFilter": true, "hide": true},
                        {"id": "threat_type", "ignoreFilter": true, "hide": true},
                        {"id": "direction", "ignoreFilter": true, "hide": true},
                        {"id": "bgp_peer_site_peer_ip", subLabel: "Name", subOrder: 1, label: "To / Dest", order: 3},
                        {"id": "route_cidr", subLabel: "CIDR", subOrder: 1, label: "Details", order: 11},
                        {"id": "range_is_floating", subLabel: "Route Type", subOrder: 2, label: "Details", order: 11}
                    ];

                    if($scope.$root.userAwareness) {
                        facets.push(
                            {"id":"tunnel_host_netbios_name", "label":"Hosts", order: 4},
                            {"id":"tunnel_host_reverse_dns", "label":"Hosts", order: 4},
                            {"id":"tunnel_host_logon_names", "label":"Users", order: 5}
                        );
                    }
                } else {
                    $timeout(function() {
                        init();
                    }, 20);
                    return;
                }

                if(!$scope.waitforfilter){
                    var screenHeight = parseInt(screen.height, 10);
                    if(screenHeight > 900){
                        $scope.pageSize = 14;
                    }
                }
                filter();

                $scope.tableConfig = {
                    aggregationConfig: $scope.aggregationConfig,
                    data: $scope.data,
                    processData: function(data,queryResults,expandable) {
                        var values = [];
                        for (var i=0;data[i];i++) {
                            if (data[i].startTime) {
                                if (data[i].endTime) {
                                    data[i].duration = moment.duration(data[i].endTime - data[i].startTime).humanize();
                                }
                                else {
                                    data[i].duration = null;
                                }
                                if (expandable) {
                                    data[i].startTimeNumber = data[i].startTime;
                                    data[i].startTime = moment(data[i].startTime).calendar();

                                    data[i].endTimeNumber = data[i].endTime;
                                    data[i].endTime = moment(data[i].endTime).calendar();
                                } else {
                                    data[i].startTimeNumber = data[i].startTime;
                                    data[i].startTime = moment(data[i].startTime).format('lll');

                                    data[i].endTimeNumber = data[i].endTime;
                                    data[i].endTime = moment(data[i].endTime).format('lll');
                                }
                            }
                            else{
                                data[i].startTime = null;
                            }
                            values.push(data[i].documentGroupId);
                            enrichVpnBypass(data[i]);
                        }
                        getAlertsForPage(values);
                    },
                    belongs : function(alert,item){
                        var belong = false;
                        if(alert.events){
                            alert.events.forEach(function(alertInnerEvent) {
                                if(!belong) {
                                    belong = (alertInnerEvent.documentGroupId === item.documentGroupId);
                                }
                            });
                        }
                        return belong;
                    },
                    showAlert : function(item){
                        var show = false;
                        $scope.alerts.forEach(function(alert) {
                            if(!show) {
                                show = $scope.tableConfig.belongs(alert,item);
                            }
                        });
                        return show;
                    },
                    getAlertsForGroup : function(item,$event){
                        $event.stopPropagation();
                        $scope.itemAlerts = [];
                        $scope.loader = true;
                        var groupAggregationConfig = _.clone(alertsAggregationConfig);
                        if(addFilter){
                            _.assign(groupAggregationConfig.filter.fields, addFilter);
                        }
                        groupAggregationConfig.filter.fields.type.values = [item.documentGroupId];
                        groupAggregationConfig.rawData = true;
                        groupAggregationConfig.fields =  [];
                        groupAggregationConfig.sourceFields = {include : ["startTime", "sendResult"]};
                        groupAggregationConfig.dataConfig.fields = [];
                        store.fetch({
                            path:"/facets?accountId=" + $state.params.accountId,
                            data: groupAggregationConfig,
                            dataObj: 'json',
                            method: 'POST',
                            success: function(data) {
                                $scope.itemAlerts = data.queryResults;
                                $scope.loader = false;
                            }
                        });
                        $scope.$root.$emit("$openPopup", "alertsPopup", "alert_" + item.documentGroupId);
                    },
                    fields : [
                        {"label":"Time","path":"startTime","width": 1,"template":"<span><time>{{item.startTime}}</time></span>"},
                        {"label":"Duration", "noSort":true, "path":"duration","width": 1,"template":"<span><time>{{item.duration}}</time></span>"},
                        {"label":"FRQ","path":"count","width": 1,"template": "<span>{{item.count}}</span>"},
                        {"label":"Type","noSort":true, "path":"type","width": 2,"template": "<span data-id='{{item.type_value}}'>{{item.type}}</span>"},
                        {"label":"From","noSort":true, "path":"site_id","width": 2,"template": '<span >{{tableConfig.fromDisplay(item)}}</span>'},
                        {"label":"To", "noSort":true, "width": 2,"template": '<span >{{tableConfig.toDisplay(item)}}</span>'},
                        {"label":"Action","noSort":true, "path":"action","width": 2,"template": '<div class="ellipsis"><span class="action-field {{item.action_value | lowercase}}">{{tableConfig.actionDisplay(item)}}</span><div>'},
                        {"label":"Details", "noSort":true, "width": 2,"template": '<span ng-if="item.type_value !== \'IPS\'">{{item.type_value === "ACCESS_RULE" ? item.appid : ""}}</span><span ng-if="item.type_value === \'IPS\'">{{item.threat_type | capitalize}}</span>'},
                        {"label":"Alerts", "noSort":true, "width": 2,"template": '<span id="alert_{{item.documentGroupId | removeSpecialChars}}" ng-click="tableConfig.getAlertsForGroup(item,$event)" style="font-size:16px" class="glyphicon glyphicon-alert hide-on-startup"></span>'}
                    ],
                    actionDisplay: function(item){
                        if (item.type_value === "QUALITY_OCCURRENCE" || item.type_value === "BGP_SESSION" || item.type_value === "BGP_ROUTING")
                            return "";

                        return item.action;
                    },
                    fromDisplay: function(item){
                        if (item.direction === "INBOUND")
                            return "External";

                        if (item.type_value === "HOST_MONITOR_UNREACHABLE"){
                            return "Cato";
                        }

                        return (item.site || item.accessLogin || item.admin || item.syncType);
                    },
                    toDisplay: function(item) {
                        if (item.direction === "INBOUND"){
                            return item.site || item.accessLogin;
                        }
                        if (item.type_value === "BGP_SESSION" || item.type_value === "BGP_ROUTING"){
                            return item.neighbor_peer_description || "N/A";
                        }
                        if (item.rt_site) {
                            return item.rt_site;
                        }
                        if (item.appid) {
                            // we don't want to show http/s as a target when we have the category of the urls in the event
                            if (item.categories_display && (item.appid === "http" || item.appid === "https")) {
                                if (item.categories_display.split(",").length > 1) {
                                    return MULTIPLE_CATEGORIES_DISPLAY_TEXT;
                                }
                                return item.categories_display;
                            }
                            return   item.appid;
                        }

                         if (item.type_value === "HOST_MONITOR_UNREACHABLE"){
                               return item.site;
                         }

                        return item.url_category_name || item.connection_destination_type|| item.controller || (item.type_value === "IPS" ? "External" : "N/A");
                    },
                    type: "events",
                    index: "events",
                    showLoader: !$scope.waitforfilter,
                    sortField: "startTime",
                    sortDir: "DESC",
                    facets: facets,
                    fromDate: $scope.dateRange.from.getTime(),
                    toDate: $scope.dateRange.to.getTime(),
                    dateField: "startTime",
                    watchDate: false,
                    hideCheckboxes: true,
                    addFilter: addFilter,
                    expand: true,
                    noSearch: true,
                    fixedLayout: true,
                    icons: icons,
                    afterUpdate: function(){
                        setChartMargin();
                    },
                    showPopUp: function(type, item, rowId){
                        var url = "";
                        var id = item[RulesService.getRuleTypeOfEntityType(type).idField];
                        var accountId = $state.params.accountId;
                        var queryConfig;

                        if (type === "appRule" || type === "accessRule" || type === "healthRule" || type == "WAN_FIREWALL_RULE" || type == "OUTBOUND_INTERNET_FIREWALL_RULE") {
                            url = "/policy?type=" + type.toUpperCase() + "&accountId=" + accountId + "&ruleId=" + id + "&effectiveTime=" + item.startTimeNumber;
                        }
                        else if(type === "urlFiltering"){
                            if (item.url_category && item.url_category !== 0) {
                                url =  "/urlFiltering?accountId="+accountId;
                                queryConfig = {
                                    "dateField": "",
                                    "fromDate": 0,
                                    "toDate": item.startTimeNumber,
                                    "from":0,"limit":20,
                                    "search":item.url_category_name,
                                    "searchField":"name",
                                    exactTerm: true,
                                    "orders":[
                                        {"path":"name","dir":"ASC"}
                                    ],
                                    "type":"URLFilteringRule"
                                };
                            }
                            else if (item.url_exception_id) {
                                url = "/urlFilteringCustomRules?accountId="+accountId;
                                queryConfig = {
                                    "dateField": "",
                                    "fromDate": 0,
                                    "toDate": item.startTimeNumber,
                                    "from":0,"limit":20,
                                    "search":item.url_category_name ? item.url_category_name : "##?C_A_T_O?##",
                                    "searchField":"name",
                                    exactTerm: true,
                                    "orders":[
                                        {"path":"name","dir":"ASC"}
                                    ],
                                    "type":"URLFilterCustomCategoryRule"
                                };
                            }
                        }
                        else if (type === "avConfigException"){
                            url =  "/avException?accountId=" + accountId + "&id="+item.file_hash;
                        }
                        store.fetch({
                            data: queryConfig,
                            dataObj: 'dataConfig',
                            method: 'POST',
                            path: url,
                            success: function(data) {
                                if (data.total === 0){
                                    if (type==="avConfigException"){
                                        id = item.file_hash;
                                        $scope.scopeSelection = {"item":item, "id":id, type: type};
                                        $scope.scopeSelection.item.avExceptionDuration = "7";
                                        $scope.$root.$emit("$openPopup", "avConfigExceptionPopup", "eventRow_"+item.documentGroupId+"_"+rowId, {topMod: -60, leftMod: $("#eventRow_"+item.documentGroupId+"_"+rowId).outerWidth() + ($scope.$root.menuClosed? -71 : -230)});
                                    }
                                    else {
                                        $scope.scopeSelection = {"id":id, type: type};
                                        $scope.$root.$emit("$openPopup", "notAvailbalePopup", "eventRow_"+item.documentGroupId+"_"+rowId, {topMod: -60, leftMod: $("#eventRow_"+item.documentGroupId+"_"+rowId).outerWidth() + ($scope.$root.menuClosed? -71 : -230)});
                                    }
                                }
                                else{
                                    $scope.actionData = {
                                        "ALLOW":{"name":"Allow","icon":"allow",class:"action-allow"},
                                        "BLOCK":{"name":"Block","icon":"block",class:"action-block"},
                                        "MONITOR":{"name":"Monitor","icon":"monitor",class:"action-monitor"},
                                        "PROMPT":{"name":"Prompt","icon":"prompt",class:"action-alert"}
                                    };

                                    $scope.scopeSelection = {"item":data.items[0], "id":id, type: type};
                                    if (type==="avConfigException"){
                                        $scope.scopeSelection.item.avExceptionDuration = "7";
                                    }
                                    else if(type === "groups"){
                                        $scope.itemsConfig = {
                                            dataURL : function(){
                                                return "/groupItems?groupId=" + $scope.scopeSelection.item.id;
                                            },
                                            noSearch: true,
                                            fields : [{"label":"Type","path":"entityType","template":"<span class='glyphicon {{item.type == \"SITE\"?\"glyphicon-globe\":\"glyphicon-user\"}}'></span><span>&nbsp;{{item.entityType|capitalize}}</span>"},
                                                {"label":"Name","path":"name","template":"<span>{{item.name}}</span>"}
                                            ]

                                        };
                                        $scope.itemsdatamodified = new Date().getTime();
                                    }
                                    $scope.$root.$emit("$openPopup", type+"Popup", "eventRow_"+item.documentGroupId+"_"+rowId, {topMod: -60, leftMod: $("#eventRow_"+item.documentGroupId+"_"+rowId).outerWidth() + ($scope.$root.menuClosed? -71 : -230)});
                                }
                            }
                        });
                    },
                    innerTable: {
                        showLoader: false,
                        defer: false,
                        noSearch: true,
                        expand: false,
                        hideFacets: true,
                        hideHead: false,
                        inheritSetting: true,
                        processData : true,
                        showPopUp: true,
                        dynamicTableConfig: function (item){
                            var fields = {
                                "fields": [
                                    {"label":"Time","path":"startTime","width": 1,"template":"<span><time>{{item.startTime}}</time></span>"},
                                    {"label":"FRQ","noSort":false, "path":"count","width": 1,"template": "<span><span>{{item.count}}</span></span>"},
                                ]
                            };
                            if (item.type_value === 'IPS') {
                                fields.fields.push(
                                    {"label":"Direction","noSort":true, "width": 1,"template":"<span>{{item.direction}}</span>"},
                                    {"label":"Src","noSort":false, "path":"tunnel_remote_ip","width": 1,"template":"<span ng-if='item.direction === \"INBOUND\"'>{{item.client_ip}}</span><span ng-if='item.direction !== \"INBOUND\"'>{{item.tunnel_host_name || item.tunnel_host_netbios_name || item.tunnel_host_reverse_dns || item.client_ip}}</span>"},
                                    {"label":"Src Country", "noSort":true,"width": 1,"template":"<span><span class=\"flag-icon flag-icon-{{(item.direction === 'INBOUND'? item.client_ip_country_code : item.tunnel_remote_ip_country_code) | lowercase}}\"/> {{item.direction === 'INBOUND'? item.client_ip_country : item.tunnel_remote_ip_country}}</span>"},
                                    {"label":"Src Port","noSort":false, "path":"client_port","width": 1,"template":"<span>{{item.client_port}}</span>"},

                                    {"label":"Dest","noSort":false, "path":"server_ip","width": 1,"template":"<span>{{item.server_ip}}</span>"},
                                    {"label":"Dest Country","noSort":true, "width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.server_ip_country_code  | lowercase}}'/> {{item.server_ip_country}}</span>"},
                                    {"label":"Dest Port","noSort":false, "path":"server_port","width": 1,"template":"<span>{{item.server_port}}</span>"}
                                );
                            } else {
                                fields.fields.push(
                                    {"label":"Src Host","noSort":false, "path":"tunnel_remote_ip","width": 1,"template":"<span>{{item.tunnel_host_name || item.tunnel_host_reverse_dns || item.tunnel_host_netbios_name || item.client_ip_hostname || item.client_ip}}</span>"},
                                    {"label":"Src Country", "noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.tunnel_remote_ip_country_code | lowercase}}'/> {{item.tunnel_remote_ip_country}}</span>"},
                                    {"label":"Dest IP","noSort":false, "path":"server_ip","width": 1,"template":"<span>{{item.server_ip}}</span>"},
                                    {"label":"Dest Country","noSort":true, "width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.server_ip_country_code  | lowercase}}'/> {{item.server_ip_country}}</span>"},
                                    {"label":"Dest Port","noSort":false, "path":"server_port","width": 1,"template":"<span>{{item.server_port}}</span>"}
                                );
                            }

                            fields.fields.push(
                                {"label":"Service", "noSort":false, "width": 1,"template": '<span><span class="">{{item.appid || item.tl_name}}</span></span>'},
                                {"label":"App Categories", "noSort":true, "width": 1,"template":"<span>{{item.categories_display ? item.categories_display : (item.app_categories ? item.app_categories : item.url_category_name)}}</span>"},
                                {"label":"HTTP host","noSort":false, "path":"host_name","width": 1,"template":"<span>{{item.host_name}}</span>"},
                                {"label":"DNS","noSort":false, "path":"server_port","width": 1,"template":"<span>{{item.server_hname}}</span>"}
                            );

                            if (item.type_value === "BYPASS_ADDRESS"){
                                fields.fields = fields.fields.slice(0, 2);
                                fields.fields.push({"label":"Dest IP","noSort":false, "path":"dstip","width": 1,"template":"<span>{{item.dstip}}</span>"});
                            }
                            else if(item.type_value === "VPN_BYPASS"){
                               fields.fields = fields.fields.slice(0, 2);
                            }
                            else if(item.type_value === "REMOTE_PORT_FORWARDING"){
                               fields.fields = fields.fields.slice(0, 2);
                               fields.fields.push({"label":"Src IP","noSort":false, "path":"srcip","width": 1,"template":"<span>{{item.srcip}}</span>"});
                               fields.fields.push({"label":"Src Port","noSort":false, "path":"sport","width": 1,"template":"<span>{{item.sport}}</span>"});
                               fields.fields.push({"label":"Dest IP","noSort":false, "path":"dstip","width": 1,"template":"<span>{{item.dstip}}</span>"});
                               fields.fields.push({"label":"Dest Port","noSort":false, "path":"dport","width": 1,"template":"<span>{{item.dport}}</span>"});
                            }
                            else if(item.type_value === "ACCESS_RULE"){
                                fields.fields.splice(10,2);
                                if($scope.$root.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"Interface","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.network_interface_name}}</span>"});
                                fields.fields.push({"label":"Subnet","noSort":false, "path":"subnet_name","width": 1,"template":"<span>{{item.subnet_name}}</span>"});
                                fields.fields.push({"label":"Rule Ref", "noSort":false, "path":"access_rule_id", "width": 1,"template":"<span ng-if='item.access_rule_id != 0' ><span id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"accessRule\""+",item,$parent.$index)'>WAN Rule {{item.access_rule_id}}</span></span><span ng-if='item.access_rule_id == 0'>Implicit block</span>"});
                            }
                            else if(item.type_value === "FW_WAN"){
                                if($scope.$root.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"Interface","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.network_interface_name}}</span>"});
                                fields.fields.push({"label":"Subnet","noSort":false, "path":"subnet_name","width": 1,"template":"<span>{{item.subnet_name}}</span>"});
                                fields.fields.push({"label":"Rule Ref", "noSort":false, "path":"fw_wan_rule_id", "width": 1,"template":"<span ng-if='item.fw_wan_rule_id != 0' ><span id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"WAN_FIREWALL_RULE\""+",item,$parent.$index)'>WAN Rule</span></span><span ng-if='item.fw_wan_rule_id == 0'>Implicit block</span>"});
                            }
                            else if(item.type_value === "APP_RULE"){
                                if ($scope.$root.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"Interface","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.network_interface_name}}</span>"});
                                fields.fields.push({"label":"Subnet","noSort":false, "path":"subnet_name","width": 1,"template":"<span>{{item.subnet_name}}</span>"});
                                fields.fields.push({"label":"Rule Ref", "noSort":false, "path":"app_rule_id", "width": 1,"template":"<span id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"appRule\""+",item,$parent.$index)'>Internet Rule {{item.app_rule_id}}</span>"});
                            }
                            else if(item.type_value === "FW_INET"){
                                if($scope.$root.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"Interface","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.network_interface_name}}</span>"});
                                fields.fields.push({"label":"Subnet","noSort":false, "path":"subnet_name","width": 1,"template":"<span>{{item.subnet_name}}</span>"});
                                fields.fields.push({"label":"Rule Ref", "noSort":false, "path":"fw_inet_rule_id", "width": 1,"template":"<span ng-if='item.fw_inet_rule_id != 0' ><span id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"OUTBOUND_INTERNET_FIREWALL_RULE\""+",item,$parent.$index)'>Internet Rule</span></span><span ng-if='item.fw_inet_rule_id == 0'>Implicit block</span>"});
                            }
                            else if(item.type_value === "URLF_RULE"){
                                if ($scope.$root.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"Interface","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.network_interface_name}}</span>"});
                                fields.fields.push({"label":"Subnet","noSort":false, "path":"subnet_name","width": 1,"template":"<span>{{item.subnet_name}}</span>"});
                                fields.fields.push({"label":"URL","noSort":true, "path":"url","width": 1,"template":"<span>{{item.url}}</span>"});
                                fields.fields.push({"label":"Rule Ref", "noSort":false, "width": 1,"template":"<span><span id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"urlFiltering\""+",item,$parent.$index)'>Category {{item.url_category != 0? item.url_category : item.url_exception_id}}</span></span>"});
                            }
                            else if(item.type_value === "SESSION_CONNECTION" && item.action_value === "FAILED"){
                                fields.fields = fields.fields.slice(0, 2);
                                fields.fields.push({"label":"Src IP","noSort":false, "path":"srcip","width": 1,"template":"<span>{{item.srcip}}</span>"});
                                fields.fields.push({"label":"Src Country","noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.srcip_country_code | lowercase}}'/> {{item.srcip_country}}</span>"});
                                fields.fields.push({"label":"Dest IP","noSort":false, "path":"dstip","width": 1,"template":"<span>{{item.dstip}}</span>"});
                                fields.fields.push({"label":"Dest Country","noSort":true, "width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.dstip_country_code  | lowercase}}'/> {{item.dstip_country}}</span>"});
                                fields.fields.push({"label":"Pop", "noSort":true, "width": 1,"template":"<span>{{item.pop_name}}</span>"});
                                fields.fields.push({"label":"Auth Type", "noSort":false, "width": 1,"template": '<span><span class="">{{item.authComponentDisplay}}</span></span>'});
                                fields.fields.push({"label":"Auth Component", "noSort":true, "width": 1,"template":"<span>{{item.loginComponentDisplay}}</span>"});
                                fields.fields.push({"label":"Auth Message", "noSort":true, "width": 1,"template":"<span>{{item.authentication_message}}</span>"});
                            }
                            else if(item.type_value === "SESSION_RECONNECT" || item.type_value === "SESSION_CHANGE_POP" || item.type_value === "SESSION_DISCONNECTED" || item.type_value === "SESSION_FAIL_OVER" || item.type_value === "SESSION_CONNECTION" || item.type_value === "SESSION_PASSIVE_DISCONNECTED" || item.type_value === "SESSION_PASSIVE_CONNECTED"){
                                fields.fields = fields.fields.slice(0, 2);
                                if(item.accessLogin){
                                    fields.fields.push({"label":"Allocated IP","noSort":false, "path":"tunnel_internal_ip","width": 1,"template":"<span>{{item.tunnel_internal_ip}}</span>"});
                                    fields.fields.push({"label":"OS Type","noSort":false, "path":"tunnel_device_type","width": 1,"template":"<span>{{item.tunnel_device_type}}</span>"});
                                    fields.fields.push({"label":"OS Version","noSort":false, "path":"tunnel_device_os_type","width": 1,"template":"<span>{{item.tunnel_device_os_type}}</span>"});
                                }
                                fields.fields.push({"label":"Client Version","noSort":true,"width": 1,"template":"<span>{{ (item.tunnel_client_version && item.siteType !== 'ACCESSLOGIN')? '(' + (item.tunnel_client_version | socketVersion:$root.tags) +  ')' : item.tunnel_client_version }}</span>"});
                                if(item.accessLogin){
                                    fields.fields.push({"label":"Release Group","noSort":false,"path":"tunnel_client_release_group","width":1,"template":"<span>{{item.tunnel_client_release_group}}</span>"});
                                }
                                fields.fields.push({"label":"Protocol","noSort":false, "path":"tunnel_type_name","width": 1,"template":"<span>{{item.tunnel_type_name}}</span>"});

                                fields.fields.push({"label":"Src IP","noSort":false, "path":"client_ip","width": 1,"template":"<span>{{item.tunnel_remote_ip}}</span>"});
                                fields.fields.push({"label":"Src Country","noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.tunnel_remote_ip_country_code | lowercase}}'/> {{item.tunnel_remote_ip_country}}</span>"});
                                fields.fields.push({"label":"Interface","noSort":true,"width": 1,"template":"<span>{{item.network_interface_name}}</span>"});
                                fields.fields.push({"label":"Pop", "noSort":true , "width": 1,"template":"<span>{{item.pop_name}}</span>"});

                                if (item.type_value === "SESSION_CONNECTION" || item.type_value === "SESSION_CHANGE_POP" || item.type_value === "SESSION_FAIL_OVER" || item.type_value === "SESSION_RECONNECT") {
                                    // fields will hold both old and new values, need to handle both cases - that why condition is complex
                                    fields.fields.push({"label":"Details", "noSort":true , "width": 1,"template":"<span>{{item.tunnel_connection_reason}}{{item.tunnel_connection_description}} " + socketSerialAndRoleTemplate});
                                } else {
                                    var templatePrefixTest = "";
                                    if (item.type_value === "SESSION_PASSIVE_DISCONNECTED") {
                                        templatePrefixTest = "Passive link disconnected. ";
                                    } else if (item.type_value === "SESSION_PASSIVE_CONNECTED") {
                                        templatePrefixTest = "Passive link connected. ";
                                    }
                                    fields.fields.push({"label":"Details", "noSort":true , "width": 1,"template": templatePrefixTest + socketSerialAndRoleTemplate});
                                }
                            }
                            else if(item.type_value === "SOCKET_FAIL_OVER") {
                                fields.fields = fields.fields.slice(0, 2);
                                fields.fields.push({"label":"Details", "noSort":true , "width": 1,"template":"<span>{{item.tunnel_connection_reason}}</span>"});
                            }
                            else if(item.type_value === "SOCKET_UPGRADE"){
                                fields.fields = fields.fields.slice(0, 2);
                                fields.fields.push({"label":"Site","noSort":false, "path":"site","width": 1,"template":"<span>{{item.site}}</span>"});
                                fields.fields.push({"label":"Old Version","noSort":false, "path":"old_version","width": 1,"template":"<span>{{item.old_version | socketVersion}}</span>"});
                                fields.fields.push({"label":"New Version","noSort":false, "path":"new_version","width": 1,"template":"<span>{{item.new_version | socketVersion}}</span>"});
                                fields.fields.push({"label":"Details","noSort":false, "path":"new_version","width": 1,"template": socketSerialAndRoleTemplate + " <span>{{item.reason}}</span>"});
                            }
                            else if(item.type_value === "SOCKET_PASSWORD_RESET") {
                                fields.fields = fields.fields.slice(0, 2);
                                fields.fields.push({"label":"Reset Type", "noSort":true , "width": 1,"template":"<span>{{(item.hw_password_reset ? 'Hardware' : 'Software') + ' Reset'}}</span>"});
                                fields.fields.push({"label":"Serial ID", "noSort":true , "width": 1,"template":"<span>{{item.device_serial_id}}</span>"});
                            }
                            else if(item.type_value === "ANTIVIRUS" || item.type_value === "NG_ANTIVIRUS"){
                                fields.fields.splice(7, 2);
                                if($scope.$root.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"URL","noSort":true, "width": 1,"template":"<div class='ellipsis' style='width:150px'><span>{{item.url}}</span></div>"});
                                if(item.type_value === "ANTIVIRUS"){
                                    fields.fields.push({"label":"Malware Name","noSort":true, "width": 1,"template":"<div><span>{{item.virus_name}}</span></div>"});
                                }
                                else{
                                    fields.fields.push({"label":"Malware Verdict","noSort":true, "width": 1,"template":"<div><span>{{item.av_scan_verdict}}</span></div>"});
                                }
                                fields.fields.push({"label":"SHA-256", "noSort":false, "width": 1,"template":"<div class='ellipsis' style='width:70px'><span style='text-overflow:ellipsis; width:100%; overflow:hidden; vertical-align: bottom;' id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"avConfigException\""+",item,$parent.$index)'>{{item.file_hash}}</span></div>"});
                                if(item.type_value === "NG_ANTIVIRUS"){
                                    fields.fields.push({"label":"Indicator","noSort":true, "width": 1,"template":"<div><span>{{!item.av_determinant || item.av_determinant === 'No indicators' || item.av_determinant.split(',').length > 2 ? 'Several risk factors' : item.av_determinant }}</span></div>"});
                                }
                                fields.fields.push({"label":"Info", "noSort":true, "width": 1,"template":"<span><a href='https://www.virustotal.com/en/search/?query={{item.file_hash}}' target='_blank'>VirusTotal</span>"});

                            } else if(item.type_value === "IPS"){
                                fields.fields.splice(9, 2);
                                if($scope.$root.tags.userAwareness){
                                    fields.fields.splice(2,0, {"label":"Src User","noSort":false, "path":"network_interface_name","width": 1,"template":"<span>{{item.tunnel_host_logon_names}}</span>"});
                                }
                                fields.fields.push({"label":"OS Type","noSort":false, "path":"os_type_name","width": 1,"template":"<span>{{item.os_type_name}}</span>"});
                                fields.fields.push({"label":"URL","noSort":true, "width": 1,"template":"<div class='ellipsis' style='width:150px'><span>{{item.url}}</span></div>"});
                                fields.fields.push({"label":"Threat Type","noSort":true, "width": 1,"template":"<div><span>{{item.threat_type | capitalize}}</span></div>"});
                                fields.fields.push({"label":"Threat Description","noSort":true, "width": 1,"template":"<div><span>{{item.meta_id === 'GEO_RESTRICTION'? '' : (item.meta_name? item.meta_name : item.meta_id)}}</span></div>"});
                                fields.fields.push({"label":"Protocol","noSort":true, "width": 1,"template":"<span>{{item.protocol}}</span>"});
                                fields.fields.push({"label":"Info", "noSort":true, "width": 1,"template":"<span><a href='https://nvd.nist.gov/vuln/detail/{{item.ref}}' target='_blank' ng-if='item.ref_type === \"cve\"'>cve-{{item.ref}}</a><a href='{{item.ref}}' target='_blank' ng-if='item.ref_type === \"url\"'>Read more</a><a href='https://www.virustotal.com/en/search/?query={{item.ref}}' target='_blank' ng-if='item.ref_type === \"md5\"'>VirusTotal</a></span>"});
                            }
                            else if(item.type_value === "USER_AWARENESS_WMI_ERROR"){
                                fields = {
                                    "fields": [
                                        {"label":"Time","path":"startTime","width": 1,"template":"<span><time>{{item.startTime}}</time></span>"},
                                        {"label":"Frequency","noSort":false, "path":"count","width": 1,"template": "<span><span>{{item.count}}</span></span>"},
                                        {"label":"Domain Controller","noSort":false, "path":"client_ip","width": 1,"template":"<span>{{item.client_ip}}</span>"},
                                        {"label":"Src Country", "noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.client_ip_country_code | lowercase}}'/> {{item.tunnel_remote_ip_country}}</span>"},
                                        {"label":"Details","noSort":true, "path":"message","width": 1,"template":"<div class='ellipsis' style='max-width:500px; vertical-align: bottom;'><span>{{item.wmi_error}}</span></div>"}
                                    ]
                                }
                            }
                            else if(item.type_value === "USER_AWARENESS_TOO_MANY_USERS") {
                                fields = {
                                    "fields": [
                                        {"label":"Time","path":"startTime","width": 1,"template":"<span><time>{{item.startTime}}</time></span>"},
                                        {"label":"Frequency","noSort":false, "path":"count","width": 1,"template": "<span><span>{{item.count}}</span></span>"},
                                        {"label":"Src Host","noSort":false, "path":"client_ip","width": 1,"template":"<span>{{item.client_ip}}</span>"},
                                        {"label":"Src Country", "noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.client_ip_country_code | lowercase}}'/> {{item.tunnel_remote_ip_country}}</span>"}
                                    ]
                                }
                            }
                            else if(item.type_value === "DIRECTORY_SERVICES"){
                                fields.fields = fields.fields.slice(0, 2);
                                fields.fields.push({"label":"Domain","noSort":false, "path":"domainName","width": 1,"template":"<span>{{item.domainName || ''}}</span>"});
                                fields.fields.push({"label":"DC Host name","noSort":false, "path":"controllerHost","width": 1,"template":"<span>{{item.controllerHost || 'N/A'}}</span>"});
                                fields.fields.push({"label":"DC Host IP","noSort":false, "path":"controllerIp","width": 1,"template":"<span>{{item.controllerIp}}</span>"});
                                fields.fields.push({"label":"Action","noSort":false, "path":"singleControllerAction","width": 1,"template":"<span class='action-field {{item.singleControllerAction_value | lowercase}}'>{{item.singleControllerAction}}</span>"});
                                fields.fields.push({"label":"Details","noSort":true, "path":"message","width": 1,"template":"<div class='ellipsis' style='max-width:500px; vertical-align: bottom;'><span>{{item.message}}</span></div>"});
                            }
                            else if(item.type_value === "QUALITY_OCCURRENCE") {
                                fields = {
                                    fields: [
                                        {label: 'Time', noSort: false, path: 'startTime', width: 3, template: "<span><time>{{item.startTime}}</time></span>"},
                                        {label: 'Action', noSort: false, path: 'action', width: 3, template: '<span>{{item.action}}</span>'},
                                        {label: 'Interface Name', noSort: false, path: 'interfaceName', width: 3, template: '<span>{{item.network_interface_name}}</span>'},
                                        {label: 'Direction', noSort: false, path: 'streamDirection', width: 2, template: '<span>{{item.streamDirection}}</span>'},
                                        {label: 'Packet Loss (%)', noSort: false, path: 'pktLoss', width: 1, template: '<span>{{item.stats.pktLoss}}</span>'},
                                        {label: 'Distance (ms)', noSort: false, path: 'latency', width: 1, template: '<span>{{item.stats.latency * 2}}</span>'},
                                        {label: 'Jitter (ms)', noSort: false, path: 'jitter', width: 1, template: '<span>{{item.stats.jitter}}</span>'},
                                        {label: 'Is Congested', noSort: false, path: 'isCongested', width: 1, template: '<span>{{item.stats.isCongested}}</span>'},
                                        {label: 'Rule Ref', noSort: false, path: "health_rule_id", width: 1, template: "<span id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp(" + "\"healthRule\"" + ", item, $parent.$index)'>Health Rule {{item.health_rule_id}}</span>"}
                                    ]
                                }
                            }
                            else if(item.type_value === "BGP_SESSION") {
                                fields = {
                                    fields: [
                                        {label: 'Time', noSort: false, path: 'startTime', width: 1, template: "<span><time>{{item.startTime}}</time></span>"},
                                        {label: 'FRQ', noSort: false, path: 'count', width: 1, template: "<span>{{item.count}}</span>"},
                                        {label: 'PoP Name', noSort: false, path: 'pop_name', width: 1,template: '<span>{{item.pop_name}}</span>'},
                                        {label: 'Site IP', noSort: false, path: 'bgp_local_ip', width: 1,template: '<span>{{item.bgp_local_ip}}</span>'},
                                        {label: 'Neighbor ASN', noSort: false, path: '', width: 1,template: '<span>{{item.bgp_peer_asn}}</span>'},
                                        {label: 'Neighbor IP', noSort: false, path: '', width: 1,template: '<span>{{item.bgp_peer_ip}}</span>'},
                                        {label: 'Disconnect reason', noSort: false, path: 'bgp_peer_disconnect_reason', width: 1,template: '<span>{{item.bgp_peer_disconnect_reason}}</span>'},
                                        {label: 'BGP Error code', noSort: false, path: 'bgp_peer_disconnect_error', width: 1,template: '<span>{{item.bgp_peer_disconnect_error_txt}}</span>'},
                                        {label: 'BGP Error Subcode', noSort: false, path: 'bgp_peer_disconnect_sub_error', width: 1,template: '<span>{{item.bgp_peer_disconnect_sub_error_txt}}</span>'},
                                        {label: 'Action', noSort: false, path: 'action', width: 1, template: '<span>{{item.action}}</span>'}
                                    ]
                                }
                            }
                            else if(item.type_value === "BGP_ROUTING"){
                                fields = {
                                    fields: [
                                        {label: 'Time', noSort: false, path: 'startTime', width: 1, template: "<span><time>{{item.startTime}}</time></span>"},
                                        {label: 'FRQ', noSort: false, path: 'count', width: 1, template: "<span>{{item.count}}</span>"},
                                        {label: 'Updated IP (in CIDR)', noSort: false, path: 'route_cidr', width: 1,template: "<span>{{item.route_cidr ? item.route_cidr : 'N/A'}}</span>"},
                                        {label: 'PoP Name', noSort: false, path: 'pop_name', width: 1,template: '<span>{{item.pop_name}}</span>'},
                                        {label: 'Action', noSort: false, path: 'action', width: 1, template: '<span>{{item.action}}</span>'},
                                        {label: 'Details', noSort: false, path: 'range_is_floating', width: 1, template: '<span>{{item.range_is_floating}}</span>'}
                                    ]
                                }
                            }
                            else if(item.type_value === "HOST_MONITOR_UNREACHABLE"){
                                  fields = {
                                    fields: [
                                        {label: 'Time', noSort: false, path: 'startTime', width: 1, template: "<span><time>{{item.startTime}}</time></span>"},
                                        {label: 'FRQ', noSort: false, path: 'count', width: 1, template: "<span>{{item.count}}</span>"},
                                        {label: 'Source', noSort: false, path: 'sourceIp', width: 1,template: "<span>{{item.srcip}}</span>"},
                                        {label: 'Destination', noSort: false, path: 'destIp', width: 1,template: '<span>{{item.dstip}}</span>'},
                                        {label: 'Action', noSort: false, path: 'action', width: 1, template: '<span>Host Unreachable</span>'},
                                    ]
                                }
                           } else if (item.type_value === "OFF_CLOUD_RECOVERY" || item.type_value === "BACKHAULING" || item.type_value === "OFF_CLOUD_TRANSPORT_CONNECT" || item.type_value === "OFF_CLOUD_TRANSPORT_DISCONNECT") {
                                fields = {
                                    fields: [
                                        {label: 'Time', noSort: false, path: 'startTime', width: 1, template: "<span><time>{{item.startTime}}</time></span>"},
                                        {label: 'FRQ', noSort: false, path: 'count', width: 1, template: "<span>{{item.count}}</span>"},
                                        {label: 'Site', noSort: false, path: 'site', width: 1, template: "<span>{{item.site}}</span>"},
                                        {label: 'Dest. Site', noSort: false, path: 'rt_site', width: 1, template: "<span>{{item.rt_site}}</span>"},
                                        {label: 'Action', noSort: false, path: 'action', width: 1, template: '<span>{{item.action}}</span>'}
                                    ]
                                }
                                fields.fields.push({label: 'Details', noSort: false, path: 'details', width: 1, template: '<span>{{item.type}} {{item.action}} from site {{item.site}} to site {{item.rt_site}}</span>'});
                            }

                            return fields;
                        },
                        dynamicAggregationConfig: function(item, aggregator){
                            var aggregationConfig = {
                                "rawData": true,
                                "filter": {
                                    "fields": {
                                        "documentGroupId" : {
                                            "label": "documentGroupId",
                                            "includeMissing": false,
                                            "values": [item.documentGroupId]
                                        }
                                    }
                                }
                            };

                            for(var bucket in aggregator.buckets){
                                var currentBucket = aggregator.buckets[bucket];
                                if(currentBucket.values.length > 0){
                                    aggregator.facetFields.forEach(function(facet){
                                        if((facet.label || facet.id) === bucket){
                                            var filterValues = [];
                                            var currentFacetData = _.findWhere(aggregator.facets, {id: facet.id});

                                            currentBucket.values.forEach(function(value){
                                                for(var i=0;currentFacetData.items[i];i++){
                                                    if((typeof value.value != 'undefined' && currentFacetData.items[i].value === value.value) || (typeof value.id !=  'undefined' && currentFacetData.items[i].id === value.id)){
                                                        filterValues.push(value.id);
                                                        break;
                                                    }
                                                }
                                            });
                                            aggregationConfig.filter.fields[currentFacetData.id || currentFacetData.label] = {
                                                label: currentFacetData.id || currentFacetData.label,
                                                includeMissing: false,
                                                values: filterValues
                                            };
                                        }
                                    });
                                }

                            }

                            if(addFilter){
                                _.assign(aggregationConfig.filter.fields, addFilter);
                            }
                            return aggregationConfig;
                        }
                    },
                    defer: $scope.waitforfilter,
                    pageSize: $scope.pageSize,
                    label: $scope.waitforfilter? "Events" : "",
                    openFilters: false
                };

                $scope.$watch('tableConfig.openFilters', function(newValue){
                    $timeout(function(){
                        setChartMargin();
                    }, 1, false);
                });
            }

            angular.element(document).ready(function(){
                ready = true;
                $filtersWrapper = $($element[0]).find('.filters-wrapper');
                $eventsCharDiv = $('#events-chart-div');
                $clearZoom =  $('.events-buttons');
                init();
            });

            function setChartMargin(){
                if(!$filtersWrapper || $filtersWrapper.length == 0) {
                    $filtersWrapper = $($element[0]).find('.filters-wrapper');
                }

                if(!ready || $filtersWrapper.length == 0) {
                    readyTimeout = $timeout(function(){
                        setChartMargin();
                    }, 50, false);
                    return;
                }

                var filtersHeight = $filtersWrapper.outerHeight();
                var auditChartHeight = $eventsCharDiv.height();

                $eventsCharDiv.css('marginTop', filtersHeight + 50);
                $filtersWrapper.css('marginTop', -(auditChartHeight + filtersHeight + 50));

                $clearZoom.css('marginTop', (auditChartHeight + filtersHeight - ($scope.pageMargin? 170 : ($filtersWrapper.find('.filters').hasClass('open')? 470 : 415))));
            }

            function setAggConfig(){
                var aggregationConfig = _.clone($scope.tableConfig.aggregationConfig);

                if(aggregationConfig.dataConfig) {
                    aggregationConfig.dataConfig.type = "count";
                    //aggregationConfig.type = "Events";
                    aggregationConfig.dataConfig.fromDate = $scope.dateRange.from.getTime();
                    aggregationConfig.dataConfig.toDate = $scope.dateRange.to.getTime();
                    aggregationConfig.dataConfig.interval = Math.max(Math.floor((aggregationConfig.dataConfig.toDate - aggregationConfig.dataConfig.fromDate) / 100), 60); // min interval size is 1 min - elastic search data provider expect to get inverval in milliseconds
                    aggregationConfig.dataConfig.dateField = "startTime";
                    aggregationConfig.index = 'events';

                    $scope.tableConfig.aggregationConfig = aggregationConfig;

                    if ($scope.tableConfig.fromDate !== aggregationConfig.dataConfig.fromDate) {
                        $scope.tableConfig.fromDate = aggregationConfig.dataConfig.fromDate;
                    }
                    if ($scope.tableConfig.toDate !== aggregationConfig.dataConfig.toDate) {
                        $scope.tableConfig.toDate = aggregationConfig.dataConfig.toDate;
                    }

                    //DateRangeService.zoomTo(aggregationConfig.dataConfig.fromDate, aggregationConfig.dataConfig.toDate, aggregationConfig.dataConfig.interval);
                    return aggregationConfig;
                }

            }

            function getAlertsForPage(values){
                alertsAggregationConfig.filter.fields.type.values = values;
                store.fetch({
                    path:"/facets?accountId=" + $state.params.accountId,
                    data: alertsAggregationConfig,
                    dataObj: 'json',
                    method: 'POST',
                    success: function(data) {
                        if(data.facets && data.facets.length > 0){
                            data.facets[0].items.forEach(function(alert){
                                $('#alert_' + $filter('removeSpecialChars')(alert.label)).show();
                            });
                        }
                    }
                });
            }

            function enrichVpnBypass(item) {
                if(item && item.type_value =='VPN_BYPASS' && item.scan_time){
                    item.bypassTime = moment(item.scan_time * 1000).format('MMMM Do YYYY, HH:mm:ss')
                }
            }

            function getDataByDates() {
                var aggregationConfig = setAggConfig();
                if(aggregationConfig){
                    $scope.auData = [];
                    store.fetch({
                        path: '/facets',
                        data: aggregationConfig,
                        dataObj: 'json',
                        method: 'POST',
                        filter: false,
                        queryParams: {'accountId': $state.params.accountId  || ""},
                        success: function(data) {
                            if(data && data.facets.length > 0){
                                var itemsData = data.facets[data.facets.length-1].items;
                                itemsData.forEach(function(item){
                                    var timeMS = GeneralUtilsService.getTimeInMiliseconds(parseInt(item.label));
                                    if (timeMS < aggregationConfig.dataConfig.fromDate ){
                                        timeMS = aggregationConfig.dataConfig.fromDate
                                    }
                                    else if (timeMS > aggregationConfig.dataConfig.toDate ){
                                        timeMS = aggregationConfig.dataConfig.toDate
                                    }
                                    item.date = new Date(timeMS);
                                    $scope.auData.push(item);
                                });
                                drawChart($scope.auData);
                            }
                        }
                    });
                }
            }

            function drawChart(data) {
                $('#events-chart-div').css('visibility', 'visible');
                if(eventsChart){
                    eventsChart.dataProvider = data;
                    eventsChart.validateData();
                }
                else {
                    eventsChart = AmCharts.makeChart("events-chart-div", {
                        "type": "serial",
                        fontFamily: 'Roboto',
                        addClassNames: true,
                        "path": "/public/javascripts/external/amcharts/",
                        "theme": "new",
                        "pathToImages": "/public/javascripts/external/amcharts/images/",
                        "categoryField": "date",
                        // "startDuration": 1,
                        "categoryAxis":{
                            gridAlpha: 0.15,
                            twoLineMode: true,
                            "minPeriod": '600ss',
                            "parseDates": true,
                            dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]
                        },
                        "chartCursor": {
                            cursorPosition: "mouse",
                            selectWithoutZooming: true,
                            "categoryBalloonDateFormat": "JJ:MM, MMM DD, YYYY"
                        },
                        "chartScrollbar": {
                            enabled: false
                        },
                        "trendLines": [],
                        "graphs": [
                            {
                                "fillAlphas": 1,
                                "id": "AmGraph-1",
                                "title": "graph 1",
                                "type": "column",
                                "dateFormat": "JJ, MMM DD, YYYY",
                                "fixedColumnWidth": 10,
                                "valueField": "count",
                                "lineColor":"#4395ce"
                            }
                        ],
                        "valueAxes": [
                            {
                                "id": "ValueAxis-1"
                            }
                        ],
                        "allLabels": [],
                        "balloon": {},
                        "dataProvider": data,
                        listeners: [
                            {
                                event: "init",
                                method: afterInit
                            }]

                    });
                }
            }

            function afterInit(chart){
                chart = chart.chart;
                chart.chartCursor.addListener("selected", handleZoom);

                chart.addListener("clickGraphItem", function (event) {
                    $scope.dateRange.from = new Date(event.item.category.getTime() - ($scope.tableConfig.aggregationConfig.dataConfig.interval));
                    $scope.dateRange.to = new Date(event.item.category.getTime() + ($scope.tableConfig.aggregationConfig.dataConfig.interval));
                });
                chart.chartCursor.addListener("onShowCursor", function (event) {
                    event.chart.chartDiv.style.cursor = "zoom-in";
                });
                chart.chartCursor.addListener("onHideCursor", function (event) {
                    event.chart.chartDiv.style.cursor = "default";
                });
            }

            function handleZoom(event) {
                var start = Math.min(event.start,event.end);
                var end = Math.max(event.start,event.end);

                $scope.dateRange.from = new Date(start);
                $scope.dateRange.to = new Date(end);
                event.chart.div.style.visibility = 'hidden';
                event.chart.chartCursor.clearSelection();
                return false;
            }

            function refreshTable() {
                if ($scope.tableConfig) {
                    $scope.tableConfig.refreshtable = new Date().getTime();
                }
            }

            $scope.$on('$destroy',function() {
                $timeout.cancel(readyTimeout);
            });
        }]
    };
});